import { Alert } from "@/components/ui/Alert";

type Props = {
    confluencePageId: number;
};

const DocumentationWindowContentError = (props: Props) => {
    const { confluencePageId } = props;

    return <Alert severity="warning" title={`Page not found (ID: ${confluencePageId})`} />;
};

export { DocumentationWindowContentError };
